import React, { useEffect, useState } from 'react';
import { Box, Typography, IconButton, useTheme, Collapse } from '@mui/material';
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { setLoading } from '../../features/authSlice';
import { getFaqList } from '../../api/faqApi';
import { showNotification } from '../../common/components/Notification/ToastifyNotification';
import LoadingSpinner from '../../common/components/LoadingSpinner';

const FAQAccordion = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.auth);
  const [expanded, setExpanded] = useState(1);
  const [faqs, setFaqs] = useState([]);

  const getFaq = async () => {
    try {
      dispatch(setLoading({
        loading: true
      }));
      const response = await getFaqList();
      setFaqs(response.data);
      dispatch(setLoading({
        loading: false
      }));
    } catch (err) {
      const errorMessage = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || err?.response?.data?.error;
      showNotification(errorMessage, 'error');
      dispatch(setLoading({
        loading: false
      }));
    }
  }

  useEffect(() => {
    getFaq();
  }, []);

  return (
    <Box sx={{ width: '100%', mt: 2 }}>
      {loading && (
        <LoadingSpinner />
      )}
      <Box sx={{
        border: '1px solid #7A869126',
        borderRadius: '8px',
        overflow: 'auto',
        height: faqs.length > 10 ? '75vh' : 'auto'
      }}>
        {faqs.map((item, index) => {
          const isExpanded = expanded === item.faq_id;

          return (
            <Box
              key={item.faq_id}
              sx={{
                borderBottom: index < faqs.length - 1 ? '1px solid #7A869126' : 'none',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  padding: '16px 20px',
                  cursor: 'pointer',
                }}
                onClick={() => setExpanded(isExpanded ? null : item.faq_id)}
              >
                <Typography
                  sx={{
                    fontSize: '16px',
                    fontWeight: 600,
                    color: theme.palette.secondary.main,
                    minWidth: '24px',
                    lineHeight: 1.4,
                  }}
                >
                  {item.sort_order}.
                </Typography>

                <Typography
                  sx={{
                    fontSize: '16px',
                    fontWeight: 600,
                    color: theme.palette.secondary.main,
                    lineHeight: 1.4,
                    flex: 1,
                    mr: 2,
                  }}
                >
                  {item.question}
                </Typography>

                {/* Expand/Collapse Icon */}
                <IconButton
                  size="small"
                  sx={{
                    padding: '2px',
                    color: theme.palette.icon.default,
                  }}
                >
                  {isExpanded ? <KeyboardArrowUp sx={{ color: theme.palette.background.dark }} /> : <KeyboardArrowDown sx={{ color: theme.palette.background.dark }} />}
                </IconButton>
              </Box>

              <Collapse
                in={isExpanded}
                timeout={300}
                easing={{
                  enter: 'cubic-bezier(0.4, 0, 0.2, 1)',
                  exit: 'cubic-bezier(0.4, 0, 0.2, 1)',
                }}
              >
                <Box
                  sx={{
                    padding: '0 0px 15px 0px',
                    paddingLeft: '14px', // Align with question text (24px number + 20px padding)
                    paddingRight: '40px',
                  }}
                >
                  <Typography
                    sx={{
                      color: theme.palette.text.main,
                      animation: isExpanded ? 'fadeIn 0.3s ease' : 'none',
                      '@keyframes fadeIn': {
                        '0%': {
                          opacity: 0,
                          transform: 'translateY(-10px)',
                        },
                        '100%': {
                          opacity: 1,
                          transform: 'translateY(0)',
                        },
                      },
                    }}
                    component="div"
                    dangerouslySetInnerHTML={{ __html: item.answer }}
                  />
                </Box>
              </Collapse>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default FAQAccordion;